<template>
  <div class="manage_page">
    <!-- 操作 -->
    <div class="manage_operate flex-rowl">
      <div class="operate_add flex-rowc" @click="handleShowPopup('')">
        <span class="iconfont icon-jiahao1"></span> Add New
      </div>
    </div>

    <!-- 收获列表 -->
    <div
      class="manage_container"
      v-loading="loading"
      element-loading-text="请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <div class="manage_list" v-if="!loading && dataList.length > 0">
        <div class="manage_item" v-for="(item, index) in dataList" :key="index">
          <div class="manage_operation flex-rowr">
            <i
              class="iconfont icon-xiugai"
              @click="handleShowPopup(item.id)"
            ></i>
            <i class="iconfont icon-guanbi" @click="handleDelete(item)"></i>
          </div>
          <div class="manage_main flex-rowl">
            <span class="iconfont icon-gerenxinxi"></span>
            <div class="manage_content flex-rowl">
              <div class="manage_content_block">
                <p v-if="COUNTRY.countryid == 1">{{ item.whname }}</p>
                <p v-else-if="COUNTRY.countryid == 8">{{ item.whname_e }}</p>
                <p v-else-if="COUNTRY.countryid == 4">{{ item.whname_y }}</p>
                <p v-else-if="COUNTRY.countryid == 2">{{ item.whname_m }}</p>
                <p><span>管理属性：</span>{{ item.managetypestr }}</p>
                <p>
                  <span>{{ item.countryidsstr }}、</span
                  ><span>{{ item.province }}、</span
                  ><span>{{ item.city }}、</span><span>{{ item.area }}、</span>
                </p>
              </div>
              <div class="manage_content_block">
                <p><span>管理联系方式：</span>{{ item.linktype }}</p>
                <p><span>业务状态管理：</span>{{ item.runstatestr }}</p>
                <p><span>代发业务模式管理：</span>{{ item.replacetypestr }}</p>
                <p>
                  <span>单次出入服务收费设置：</span
                  >{{ USERINFO.countryExrateObj.moneyslog }}{{ item.fee_set ? item.fee_set : 0 }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="no_data" v-if="!loading && dataList.length == 0">
        <el-empty description="暂无内容"></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="commodity_pagin flex-rowc">
      <!-- jumper -->
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="15"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <!-- 收货信息弹窗 -->
    <el-dialog
      :title="formData.id ? '编辑仓库信息' : '新增仓库信息'"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      @close="handleCloseDialog"
    >
      <div class="el-dialog-div">
        <el-form
          :model="formData"
          label-position="top"
          ref="formData"
          :rules="ruleFormDate"
        >
          <el-row :gutter="20">
            <el-col :span="24" v-if="COUNTRY.countryid == 1">
              <el-form-item label="仓库名称" prop="whname">
                <el-input
                  v-model="formData.whname"
                  placeholder="请输入仓库名称"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-else-if="COUNTRY.countryid == 8">
              <el-form-item label="仓库名称英文" prop="whname_e">
                <el-input
                  v-model="formData.whname_e"
                  placeholder="请输入仓库名称英文"
                  maxlength="60"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-else-if="COUNTRY.countryid == 4">
              <el-form-item label="仓库名称越南文" prop="whname_y">
                <el-input
                  v-model="formData.whname_y"
                  placeholder="请输入仓库名称越南文"
                  maxlength="60"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-else-if="COUNTRY.countryid == 2">
              <el-form-item label="仓库名称俄语" prop="whname_m">
                <el-input
                  v-model="formData.whname_m"
                  placeholder="请输入仓库名称俄语"
                  maxlength="60"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- <el-col :span="12">
              <el-form-item label="仓库服务类型" prop="whtype">
                <el-radio-group v-model="formData.whtype">
                  <el-radio label="私有仓"></el-radio>
                  <el-radio label="公共服务仓"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="管理属性" prop="managetype">
                <el-radio-group v-model="formData.managetype">
                  <el-radio label="工厂"></el-radio>
                  <el-radio label="第三方服务机构"></el-radio>
                  <el-radio label="标准仓库"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- <el-col :span="12">
              <el-form-item label="选择国家" prop="countryids">
                <el-select
                  v-model="formData.countryids"
                  @change="handleCountryChange"
                  placeholder="选择国家"
                >
                  <el-option
                    :key="item.countryid"
                    :label="item.countryname"
                    :value="item.countryid"
                    v-for="item in countryList"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item label="省/直辖市" prop="province">
                <el-input
                  v-model="formData.province"
                  placeholder="请输入省/直辖市"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="城市" prop="city">
                <el-input
                  v-model="formData.city"
                  placeholder="请输入城市"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="所在区域" prop="area">
                <el-input
                  v-model="formData.area"
                  placeholder="请输入所在区域"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="详细地址" prop="addr">
            <el-input
              type="textarea"
              v-model="formData.addr"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="管理人姓名" prop="manager">
                <el-input
                  v-model="formData.manager"
                  placeholder="请输入管理人姓名"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="管理人联系方式" prop="linktype">
                <el-input
                  v-model="formData.linktype"
                  placeholder="请输入管理人联系方式"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注" prop="other">
            <el-input
              type="textarea"
              v-model="formData.other"
              placeholder="请输入备注"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="是否启用" prop="isuse">
                <el-radio-group v-model="formData.isuse">
                  <el-radio :label="true">启用</el-radio>
                  <el-radio :label="false">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="false">
              <el-form-item label="业务状态管理" prop="runstate">
                <el-radio-group v-model="formData.runstate">
                  <el-radio label="1">开启入库&代发业务</el-radio>
                  <el-radio label="2">关闭入库&代发业务</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="false">
              <el-form-item label="代发业务模式管理" prop="replacetypeList">
                <el-checkbox-group v-model="formData.replacetypeList">
                  <el-checkbox label="1">一件代发（to 零售）</el-checkbox>
                  <el-checkbox label="2">大货代发（to 集运）</el-checkbox>
                  <el-checkbox label="3">退换货处理（to 零售）</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="false">
              <el-form-item
                :label="
                  '单次出入服务收费设置' +
                  '（' +
                  USERINFO.countryExrateObj.moneyslog +
                  '）'
                "
                prop="fee_set"
              >
                <div class="flex-rowl">
                  <span style="white-space: nowrap"
                    >{{ USERINFO.countryExrateObj.moneyslog }}：</span
                  >
                  <el-input
                    v-model="formData.fee_set"
                    placeholder="请输入单次出入服务收费设置"
                    maxlength="10"
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="发货服务类型" prop="ltid">
                <el-radio v-model="formData.ltid" :label="1">{{
                  ltidstr
                }}</el-radio>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="出入库服务收费人民币会算" prop="fee_rmb">
                <el-input
                  v-model="formData.fee_rmb"
                  placeholder="请输入出入库服务收费人民币会算"
                  maxlength="10"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleCloseDialog">取 消</el-button>
        <el-button
          type="primary"
          size="medium"
          class="custom-button"
          @click="handleSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
    
    <script>
import { getCountry, getSendServiceList } from "../../api/api";
import {
  getSpecialUserResourceList,
  addSpecialUserResource,
  editSpecialUserResource,
  getSpecialUserResourceDetail,
  delSpecialUserResource,
} from "../../api/managCenter";
import { mapState } from "vuex";
export default {
  name: "warehouseInfo",
  data() {
    return {
      showDialog: false,
      // 参数

      userCompanyCard: "",
      formData: {
        id: "",
        whname: "",
        isuse: true,
        openid: "",
        whname_e: "",
        whname_y: "",
        whname_m: "",
        whname_t: "",
        whname_r: "",
        whname_l: "",
        whname_x: "",
        whtype: "私有仓", // 仓库服务类型 =私有仓 公共服务仓
        managetype: "标准仓库", // 管理属性 =工厂 第三方服务机构 标准仓库
        countryids: "",
        province: "",
        city: "",
        area: "",
        addr: "",
        manager: "", // 管理人姓名
        linktype: "", // 管理人联系方式
        other: "", // 备注
        runstate: "1", // 业务状态管理 =1=开启入库&代发业务 2=关闭入库&代发业务
        replacetypeList: [], // 代发业务模式管理 =1=一件代发（to 零售） 2=大货代发（to 集运） 3=退换货处理（to 零售）
        replacetype: "", // 代发业务模式管理 =1=一件代发（to 零售） 2=大货代发（to 集运） 3=退换货处理（to 零售）
        fee_set: 0, // 单次出入库服务收费设置
        fee_cny: "", // 出入库服务收费币种
        fee_rmb: 0, // 出入库服务收费人民币会算
        ltid: "", // 发货服务类型
      },
      // 表单校验
      ruleFormDate: {
        whname: [
          {
            required: true,
            message: "请输入仓库名称",
            trigger: "blur",
          },
        ],
        // whtype: [
        //   {
        //     required: true,
        //     message: "请选择仓库服务类型",
        //     trigger: "change",
        //   },
        // ],
        managetype: [
          {
            required: true,
            message: "请选择管理属性",
            trigger: "change",
          },
        ],
        // countryids: [
        //   {
        //     required: true,
        //     message: "请选择国家",
        //     trigger: "change",
        //   },
        // ],
        province: [
          {
            required: true,
            message: "请输入省/直辖市",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "请输入城市",
            trigger: "blur",
          },
        ],
        area: [
          {
            required: true,
            message: "请输入所在区域",
            trigger: "blur",
          },
        ],
        addr: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],
        manager: [
          {
            required: true,
            message: "请输入管理人姓名",
            trigger: "blur",
          },
        ],
        linktype: [
          {
            required: true,
            message: "请输入管理人联系方式",
            trigger: "blur",
          },
        ],
        // runstate: [
        //   {
        //     required: true,
        //     message: "请选择业务状态管理",
        //     trigger: "change",
        //   },
        // ],
        // replacetypeList: [
        //   {
        //     required: true,
        //     message: "请选择代发业务模式管理",
        //     trigger: "change",
        //   },
        // ],
        // fee_set: [
        //   {
        //     required: true,
        //     message: "请输入单次出入库服务收费设置",
        //     trigger: "blur",
        //   },
        // ],
        // fee_rmb: [
        //   {
        //     required: true,
        //     message: "请输入出入库服务收费人民币会算",
        //     trigger: "blur",
        //   },
        // ],
        isuse: [
          {
            required: true,
            message: "请选择是否启用",
            trigger: "change",
          },
        ],
      },
      ltidstr: "",

      countryList: [], // 国家
      provinceList: [], // 省
      cityList: [], // 市
      areaList: [], // 区

      loading: false,
      // 物流记录
      dataList: [],
      // 物流记录数量
      totalNum: 0,
      // 物流记录参数
      dataForm: {
        pageindex: 1,
        pagesize: 15,
        keyword: "",
        isuse: "", // 是否启用 =1=启用 0=停用
        openid: "",
        whtype: "", // 仓库服务类型 =私有仓 公共服务仓
        managetype: "", // 管理属性 =工厂 第三方服务机构 标准仓库
        countryids: "", // 所在国家
        runstate: "", // 业务状态管理 =1=开启入库&代发业务 2=关闭入库&代发业务
        replacetype: "", // 代发业务模式管理 =1=一件代发（to 零售） 2=大货代发（to 集运） 3=退换货处理（to 零售）
        fee_cny: "", // 出入库服务收费币种
      },
      // 物流详情
      dataDetail: {},
    };
  },
  computed: {
    ...mapState(["COUNTRYLIST", "OPENID", "USERINFO", "COUNTRY"]),
  },
  mounted() {
    this.dataForm.openid = this.OPENID;
    this.dataForm.countryids = this.USERINFO.countryExrateObj.countryid;

    this.getSpecialUserResourceList();
    this.getCountry();
    this.getSendServiceList();
  },
  methods: {
    // 手机号隐藏四位
    formatPhone(row) {
      const phone = row.linktype;
      let hiddenPhone = "";
      if (phone.length === 11) {
        hiddenPhone = phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
      }

      return hiddenPhone;
    },

    // 获取国家
    getCountry() {
      getCountry().then((res) => {
        this.countryList = res;
      });
    },

    getSendServiceList() {
      let params = {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
      };
      getSendServiceList(params).then((res) => {
        console.log(res);
        res.list.forEach((item) => {
          if (item.id == 1) {
            this.formData.ltid = item.id;
            this.ltidstr = item.ltname;
          }
        });
      });
    },

    // 获取物流记录
    getSpecialUserResourceList() {
      this.loading = true;
      getSpecialUserResourceList(this.dataForm).then((res) => {
        this.dataList = res.list;
        this.totalNum = res.total;
        this.loading = false;
      });
    },
    // 新增物流记录
    addSpecialUserResource() {
      // 将formData对象赋值给新的newFormData
      let newFormData = { ...this.formData };
      // 删除newFormData中的replacetypeList
      delete newFormData.replacetypeList;
      // 给newFormData中replacetype重新赋值，其值为formData中replacetypeList转换的字符串
      newFormData.replacetype = this.formData.replacetypeList.join(",");
      addSpecialUserResource(newFormData).then((res) => {
        if (res.result) {
          this.getSpecialUserResourceList();
          this.showDialog = false;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 编辑物流记录
    editSpecialUserResource() {
      // 将formData对象赋值给新的newFormData
      let newFormData = { ...this.formData };
      // 删除newFormData中的replacetypeList
      delete newFormData.replacetypeList;
      // 给newFormData中replacetype重新赋值，其值为formData中replacetypeList转换的字符串
      newFormData.replacetype = this.formData.replacetypeList.join(",");

      editSpecialUserResource(newFormData).then((res) => {
        if (res.result) {
          this.getSpecialUserResourceList();
          this.showDialog = false;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 获取物流记录详情
    getSpecialUserResourceDetail() {
      getSpecialUserResourceDetail({ id: this.formData.id }).then((res) => {
        this.dataDetail = res;

        this.formData.whname = res.whname ? res.whname : "";
        this.formData.whname_e = res.whname_e ? res.whname_e : "";
        this.formData.whname_y = res.whname_y ? res.whname_y : "";
        this.formData.whname_m = res.whname_m ? res.whname_m : "";
        this.formData.whname_t = res.whname_t ? res.whname_t : "";
        this.formData.whname_r = res.whname_r ? res.whname_r : "";
        this.formData.whname_l = res.whname_l ? res.whname_l : "";
        this.formData.whname_x = res.whname_x ? res.whname_x : "";
        this.formData.whtype = res.whtype ? res.whtype : "私有仓";
        this.formData.managetype = res.managetype ? res.managetype : "标准仓库";
        // this.formData.countryids = res.countryids? parseInt(res.countryids) : ''
        this.formData.province = res.province ? res.province : "";
        this.formData.city = res.city ? res.city : "";
        this.formData.area = res.area ? res.area : "";
        this.formData.addr = res.addr ? res.addr : "";
        this.formData.manager = res.manager ? res.manager : "";
        this.formData.linktype = res.linktype ? res.linktype : "";
        this.formData.other = res.other ? res.other : "";
        this.formData.runstate = res.runstate ? res.runstate : "1";
        this.formData.replacetypeList = res.replacetype
          ? res.replacetype.split(",")
          : [];
        this.formData.replacetype = res.replacetype ? res.replacetype : "";
        this.formData.fee_set = res.fee_set ? res.fee_set : "";
        this.formData.fee_rmb = res.fee_rmb ? res.fee_rmb : 0;
        this.formData.isuse = res.isuse ? res.isuse : true;
        this.formData.ltid = res.ltid ? res.ltid : 1;

        // this.getCountry();
      });
    },

    // 删除物流记录
    delSpecialUserResource(id) {
      delSpecialUserResource({ id, openid: this.OPENID }).then((res) => {
        if (res.result) {
          this.getSpecialUserResourceList();
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    handleCloseDialog() {
      this.showDialog = false;
      // 清空数据
      this.formData = {
        id: "",
        whname: "",
        isuse: "",
        openid: this.OPENID,
        whname_e: "",
        whname_y: "",
        whname_m: "",
        whname_t: "",
        whname_r: "",
        whname_l: "",
        whname_x: "",
        whtype: "私有仓",
        managetype: "标准仓库",
        // countryids: "",
        province: "",
        city: "",
        area: "",
        addr: "",
        manager: "",
        linktype: "",
        other: "",
        runstate: "",
        replacetypeList: [],
        replacetype: "",
        fee_set: "",
        fee_rmb: 0,
      };
      this.$refs["formData"].resetFields();
    },

    // 显示弹窗
    handleShowPopup(id) {
      if (id) {
        this.formData.id = id;
        this.getSpecialUserResourceDetail();
        this.showDialog = true;
      } else {
        this.showDialog = true;
      }
    },

    // 分页
    handleCurrentChange(e) {
      this.dataForm.pageindex = e;
      this.getSpecialUserResourceList();
    },

    // 复制新增数据
    handleCopy(row) {
      this.formData = {
        id: "",
        whname: row.whname,
        isuse: row.isuse,
        openid: row.openid,
        whname_e: row.whname_e,
        whname_y: row.whname_y,
        whname_m: row.whname_m,
        whname_t: row.whname_t,
        whname_r: row.whname_r,
        whname_l: row.whname_l,
        whname_x: row.whname_x,
        whtype: row.whtype,
        managetype: row.managetype,
        countryids: row.countryids,
        city: row.city,
        area: row.area,
        addr: row.addr,
        manager: row.manager,
        linktype: row.linktype,
        other: row.other,
        runstate: row.runstate,
        replacetype: row.replacetype,
        fee_set: row.fee_set,
        fee_cny: row.fee_cny,
        fee_rmb: row.fee_rmb,
      };
      this.addSpecialUserResource();
    },

    // 删除数据
    handleDelete(row) {
      this.delSpecialUserResource(row.id);
    },

    // 提交数据
    handleSubmit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.formData.openid = this.OPENID;
          this.formData.fee_cny = this.USERINFO.countryExrateObj.countryid;
          this.formData.countryids = this.USERINFO.countryExrateObj.countryid;
          if (this.formData.id) {
            this.editSpecialUserResource();
          } else {
            this.addSpecialUserResource();
          }
        }
      });
    },
  },
};
</script>
    <style lang="less" scoped>
.manage_container {
  margin: 30px auto;
  height: 55vh;
  overflow-y: scroll;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;
  }
  .manage_list {
    .manage_item {
      width: 1300px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(214, 214, 214, 0.5);
      border-radius: 30px;
      padding: 15px 20px 25px 50px;
      box-sizing: border-box;
      margin-bottom: 10px;
      .manage_operation {
        .icon-xiugai {
          cursor: pointer;
          font-size: 28px;
        }
        .icon-guanbi {
          cursor: pointer;
          font-size: 24px;
          font-weight: bold;
          margin-left: 20px;
        }
      }
      .manage_main {
        .icon-gerenxinxi {
          font-size: 34px;
          margin-right: 34px;
        }
        .manage_content {
          align-items: flex-start;
          .manage_content_block {
            &:first-child {
              width: 420px;
              flex-shrink: 0;
            }
            color: #aaaaaa;
            h1 {
              font-size: 18px;
              font-weight: 600;
              margin-bottom: 8px;
            }
            p {
              font-size: 16px;
              margin-bottom: 8px;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}

.el-dialog-div {
  height: 54vh;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .el-select {
    width: 100%;
  }
}
</style>